import { gate } from 'hub-http/gates';
export const RRL_USE_TRANSITIONAL_SELECT = gate('RRL:UseTransitionalSelect');
export const CDP_DISPLAY_OPTIMIZED = gate('CRM:Properties:FormControlDisplayOptimized');